import { IndustryConfig } from '../../../types'

export const healthWellnessServicesConfig: IndustryConfig = {
  id: 'health-wellness-services',
  name: 'Health & Wellness Services',
  icon: '🧘',
  description: 'Health and wellness service providers focused on service mix and membership optimization',
  
  businessTypes: [
    {
      id: 'fitness-studio',
      name: 'Fitness Studio/Gym',
      description: 'Fitness centers, yoga studios, and specialized workout facilities'
    },
    {
      id: 'wellness-center',
      name: 'Wellness Center',
      description: 'Holistic wellness centers offering multiple health and wellness services'
    },
    {
      id: 'spa-salon',
      name: 'Spa & Beauty Salon',
      description: 'Day spas, beauty salons, and aesthetic treatment centers'
    },
    {
      id: 'personal-services',
      name: 'Personal Wellness Services',
      description: 'Personal trainers, nutritionists, and individual wellness practitioners'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'membership-subscriptions',
      name: 'Membership & Subscriptions',
      description: 'Recurring revenue from gym memberships and wellness program subscriptions',
      intelligenceValue: "We'll monitor membership pricing trends, retention rates, and competitor membership models to help you optimize your membership structure and reduce churn."
    },
    {
      id: 'service-packages',
      name: 'Service Packages',
      description: 'Bundled wellness services, class packages, and treatment series',
      intelligenceValue: "We'll track package pricing strategies, utilization rates, and customer preferences to help you design more profitable service bundles and optimize your service mix."
    },
    {
      id: 'individual-sessions',
      name: 'Individual Sessions',
      description: 'Personal training, private lessons, and individual treatment sessions',
      intelligenceValue: "We'll monitor session pricing benchmarks, demand patterns, and scheduling optimization to help you maximize individual service revenue and trainer utilization."
    },
    {
      id: 'retail-products',
      name: 'Retail & Products',
      description: 'Wellness products, supplements, equipment, and retail merchandise',
      intelligenceValue: "We'll track product demand trends, margin opportunities, and supplier changes to help you optimize your retail offerings and increase ancillary revenue."
    }
  ],
  
  supplierCategories: [
    {
      id: 'equipment-supplies',
      name: 'Equipment & Supplies',
      suppliers: ['Fitness equipment manufacturers', 'Yoga/wellness supplies', 'Beauty product suppliers', 'Cleaning supplies', 'Retail inventory'],
      spendRanges: ['Under $3K', '$3K-$15K', '$15K-$75K', 'Over $75K']
    },
    {
      id: 'facility-operations',
      name: 'Facility Operations',
      suppliers: ['Rent/lease payments', 'Utilities', 'Insurance providers', 'Maintenance services', 'Security systems'],
      spendRanges: ['Under $5K', '$5K-$20K', '$20K-$75K', 'Over $75K']
    },
    {
      id: 'staff-training',
      name: 'Staff & Training',
      suppliers: ['Instructor wages', 'Certification programs', 'Training providers', 'Continuing education', 'Contractor services'],
      spendRanges: ['Under $4K', '$4K-$18K', '$18K-$60K', 'Over $60K']
    },
    {
      id: 'marketing-technology',
      name: 'Marketing & Technology',
      suppliers: ['Scheduling software', 'Payment processing', 'Marketing platforms', 'Social media advertising', 'Website services'],
      spendRanges: ['Under $1K', '$1K-$5K', '$5K-$20K', 'Over $20K']
    }
  ],
  
  competitiveFactors: [
    'Location convenience',
    'Facility quality',
    'Staff expertise',
    'Service variety',
    'Pricing competitiveness',
    'Class scheduling',
    'Customer experience',
    'Community atmosphere',
    'Equipment quality',
    'Results achievement'
  ]
}